import React, { useRef } from "react";
import { motion, useScroll, useSpring, useTransform } from "framer-motion";
import HeroSection from "./Landing/HeroSection";
import LandingFooter from "./Landing/LandingFooter";
import PricingSection from "./Landing/PricingSection";
import ServicesSection from "./Landing/ServicesSection";
import SupportedChainsSection from "./Landing/SupportedChainsSection";
const ScrollAnimatedSection = ({ id, className, children }) => {
  const sectionRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start 92%", "end 8%"],
  });

  const smoothProgress = useSpring(scrollYProgress, {
    stiffness: 130,
    damping: 26,
    mass: 0.6,
  });

  const opacity = useTransform(
    smoothProgress,
    [0, 0.2, 0.8, 1],
    [0.72, 1, 1, 0.82],
  );
  const y = useTransform(smoothProgress, [0, 0.5, 1], [40, 0, -24]);
  const scale = useTransform(smoothProgress, [0, 0.5, 1], [0.99, 1, 0.995]);

  return (
    <motion.section
      id={id}
      ref={sectionRef}
      style={{ opacity, y, scale }}
      className={`${className} will-change-transform`}
    >
      {children}
    </motion.section>
  );
};

const Index = () => {
  return (
    <section className="relative z-10 min-h-screen overflow-hidden bg-[#131313] text-white">
      <div key="services">
        <ScrollAnimatedSection
          id="services"
          className="relative z-10 flex min-h-screen w-full scroll-mt-32 flex-col items-center justify-start px-6 pt-36"
        >
          <div className="flex w-full flex-col items-center text-center md:px-10">
            <HeroSection />
          </div>
        </ScrollAnimatedSection>
      </div>

      <div className="relative z-10 flex w-full flex-col items-center px-0">
        <div
          className="w-full bg-landing-section min-h-screen"
          key="blockchains"
        >
          <ScrollAnimatedSection
            id="blockchains"
            className="flex w-full items-center justify-center px-2 pb-6 sm:pb-10"
          >
            <ServicesSection />
          </ScrollAnimatedSection>
        </div>

        <div className="w-full overflow-hidden">
          <ScrollAnimatedSection
            id="networks"
            className="flex w-full items-center justify-center px-2 pb-6 sm:pb-10"
          >
            <SupportedChainsSection />
          </ScrollAnimatedSection>
        </div>

        <div className="w-full min-h-screen overflow-hidden">
          <ScrollAnimatedSection
            id="pricing"
            className="flex w-full items-center justify-center pt-8"
          >
            <PricingSection />
          </ScrollAnimatedSection>
        </div>

        <div className="w-full overflow-hidden">
          <ScrollAnimatedSection
            id="documentation"
            className="flex w-full items-stretch justify-center pb-0 pt-0"
          >
            <LandingFooter />
          </ScrollAnimatedSection>
        </div>
      </div>
    </section>
  );
};

export default Index;
